import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Gift, Sparkles, Scissors, Share2 } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { PoweredBy } from "@/components/Footer";

const Perk = ({ icon: Icon, text }) => (
  <div className="flex items-center gap-3 text-sm text-slate-300"><Icon className="w-4 h-4 text-[#3ad7ff] shrink-0" />{text}</div>
);

export default function ReferralLanding() {
  const { code } = useParams();
  const { t } = useI18n();
  const [info, setInfo] = useState(null);
  useEffect(() => {
    api.get(`/referral/${code}/info`).then((r) => {
      setInfo(r.data);
      localStorage.setItem("clipx_ref", JSON.stringify({ sid: code.toUpperCase(), at: Date.now(), name: r.data.name, bonus: r.data.reward_friend }));
    }).catch(() => setInfo(false));
  }, [code]);
  return (
    <div className="min-h-screen bg-[#04050a] text-slate-200 grid place-items-center px-5 py-16 relative overflow-hidden" data-testid="referral-landing">
      <PoweredBy />
      <div className="absolute -left-40 top-10 w-[520px] h-[520px] rounded-full bg-[#2f7bff]/20 blur-[140px]" />
      <div className="absolute -right-40 bottom-0 w-[480px] h-[480px] rounded-full bg-[#ff2bd6]/15 blur-[140px]" />
      <div className="relative max-w-xl w-full cx-card rounded-3xl p-8 sm:p-10 cx-rise">
        <img src="/logo-wide.png" alt="CLIP-EX" className="h-9" />
        {info === null ? <div className="cx-skel h-40 mt-8 rounded-xl" /> : (
          <>
            <div className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#22e3a1]/15 border border-[#22e3a1]/40 px-3 py-1 text-xs text-[#22e3a1]" data-testid="referral-landing-bonus">
              <Gift className="w-3.5 h-3.5" />+{info ? info.reward_friend : 3} clips
            </div>
            <h1 className="font-display font-bold text-4xl sm:text-5xl mt-4 leading-tight text-white" data-testid="referral-landing-title">
              {info ? t("ref.invited_by").replace("{name}", info.name) : t("ref.invited")}
            </h1>
            <p className="text-slate-400 mt-4 text-sm sm:text-base">{info ? t("ref.banner_bonus").replace("{n}", info.reward_friend) : t("ref.landing_bad")}</p>
            <div className="mt-6 space-y-2.5">
              <Perk icon={Sparkles} text={t("ref.landing_sub")} />
              <Perk icon={Scissors} text="TikTok · Reels · Shorts · 9:16" />
              <Perk icon={Share2} text="Twitch · Kick · YouTube · OBS" />
            </div>
            <Link to="/login?mode=register" data-testid="referral-landing-cta" className="cx-btn mt-8 w-full rounded-full py-3.5 text-sm font-semibold flex items-center justify-center gap-2">
              <Gift className="w-4 h-4" />{t("ref.landing_cta")}
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
